<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="descricao-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-descricao-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Data Nascimento -->
          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Data Início"
              label-for="v-dataInicio"
            >
              <flat-pickr
                id="v-dataInicio"
                v-model="form.dataInicio"
                data-cy="data-inicio-input"
                name="fieldDate"
                class="form-control"
                :config="{
                  altInput: true,
                  altFormat: 'd/m/Y',
                  enableTime: false,
                  dateFormat: 'Y-m-d\\TH:i:ss\\Z'
                }"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- Data Nascimento -->
          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Data Termíno"
              label-for="v-dataTermino"
            >
              <flat-pickr
                id="v-dataTermino"
                v-model="form.dataTermino"
                data-cy="data-termino-input"
                name="fieldDate"
                class="form-control"
                :config="{
                  altInput: true,
                  altFormat: 'd/m/Y',
                  enableTime: false,
                  dateFormat: 'Y-m-d\\TH:i:ss\\Z'
                }"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import flatPickr from 'vue-flatpickr-component'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('convenioSettingsModule', {
      convenio: state => state.convenio,
    }),
    canInsert() {
      return this.verificarPermissao('ROLE_CONVENIO_INSERIR')
    },
    canEdit() {
      return this.verificarPermissao('ROLE_CONVENIO_ATUALIZAR')
    },
    canEditOrInsert() {
      if (this.form.id) {
        return this.canEdit
      }
      return this.canInsert
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    flatPickr,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Convênios',
      required,
      form: {
        id: '',
        descricao: '',
        dataInicio: '',
        dataTermino: '',
        ativo: true,
      },
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.convenio))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('convenioSettingsModule/resetConvenio')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('convenioSettingsModule/editConvenio', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('convenioSettingsModule/insertNewConvenio', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        id: '',
        descricao: '',
        dataInicio: '',
        dataTermino: '',
        ativo: true,
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
